import Vue from 'vue'
import Vuex from "vuex"
var baseURL = '';
import axios from 'axios';
Vue.use(Vuex)
// let store = {
//   area:[],
//   categorys:[],
//   enterprise_id:'',
//   getDefault:function(){
//       axios.get(`${baseURL}/api/admin/getdefault`).then(res=>{
//         this.area=res.data.data.areas;
//         this.categorys=res.data.data.categorys;
//       })
//   },
//   mutations:{
//     setId(state,id){
//       state.enterprise_id = id;
//     }
//   },
//   getters:{
//     getId(state){
//       return state.enterprise_id
//     }
//   }
// }
// store.getDefault();
const store = {
  state: {
    inDate: ''
  },
  mutations:{
    setInDate(state,inDate){
      state.inDate = inDate;
    }
  },
  getters:{

  }
}
export default new Vuex.Store(store); 
